// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"96":"vendors","644":"react","678":"mui","933":"auth"}[chunkId] || chunkId) + "." + {"96":"f026282a11fc4c771b8b","175":"b344036d3e0ab98f945b","644":"29574ffa623afe5479ae","678":"127b6922bfd89190cf28","766":"166baac56c615844a24b","933":"8828a6b6b08da1b39e4c"}[chunkId] + ".js";
};